import { render, staticRenderFns } from "./add-zbr.vue?vue&type=template&id=85f56214&"
import script from "./add-zbr.vue?vue&type=script&lang=js&"
export * from "./add-zbr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports